import React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const InfoBox = ( props ) => {

    const Styles = {
        //147 recommended marginTop: "147%",
        marginTop: "115%",
        BackgroundColor: "white"

        //transform: "rotate(180deg)"
    }

    const TextStyles ={
        "text-align": "left"
    }

    return (
        <div style={Styles}>
        <Accordion defaultActiveKey="0">
            <Card>
            <Card.Header >
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0" >
                <Card.Body>
                <div>
                    <div>{`${props.link_id.toLowerCase()}`}</div>
                    <div>{`4.5 Stars`}</div>
                    <div>{`Link Address: ${props.sa.toLowerCase()}`}</div>
                    <div>{`Community Board: ${props.cb}`}</div>
                </div>
                </Card.Body>
            </Accordion.Collapse>
            </Card>    
        </Accordion>
        </div>
    )
};

export default InfoBox;


//add a click function in your info box

// and then in MAp when a button in a map is clicked invoke that function
